(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mt-cart-countdown')) {
  customElements.define('mt-cart-countdown', class extends HTMLElement {
    connectedCallback() {
      this.observer?.disconnect();
      const source = document.querySelector('#mt-halloween-banner .mt-halloween__timer');
      if (!source) { this.hidden = true; return; }
      const fields = ['days', 'hours', 'minutes', 'seconds'].map(unit => [source.querySelector('[data-' + unit + ']'), this.querySelector('[data-' + unit + ']')]);
      const sync = () => fields.forEach(([from, to]) => {
        if (from && to && to.textContent !== from.textContent) to.textContent = from.textContent;
      });
      sync();
      this.observer = new MutationObserver(sync);
      this.observer.observe(source, { childList: true, characterData: true, subtree: true });
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
